module.exports = __webpack_public_path__ + "static/media/deepsing_white.366f8f4d.png";